import { useState } from "react";
import { Icon } from "../components/Icon";
import { formatTime } from "../format";
import { useStore } from "./useStore";

const RATES = [0.65, 0.8, 1, 1.2, 1.5];

export function PersistentPlayer() {
  const store = useStore();
  const { player } = store;
  const ps = store.playerState;
  // While the thumb is held the slider shows the drag position; the seek is committed on release.
  const [drag, setDrag] = useState<number | null>(null);
  const visible = !!ps.program && !ps.program.practiceToken;
  if (!visible || !ps.program) return <section className="persistent-player" id="persistent-player" aria-label="Audio player" hidden />;

  const caption = ps.error ? "Playback interrupted" : ps.playing ? "Listening" : ps.snapshot?.completed ? "Complete" : "Paused";
  const toggle = () => {
    const current = player.getState();
    if (current.playing) player.pause();
    else if (current.snapshot?.completed) player.restart();
    else player.play();
  };
  const commitSeek = () => { if (drag !== null) { player.seek(drag); setDrag(null); } };
  const changeRate = (rate: number) => {
    player.setRate(rate);
    const id = player.getState().languageId;
    if (id) { store.progressFor(id).storyPrefs.speed = rate; store.save(); }
  };

  return (
    <section className="persistent-player" id="persistent-player" aria-label="Audio player" key={ps.languageId + ":" + ps.program.id}>
      <div className="player-track">
        <span className="player-track-icon"><Icon name="audio" /></span>
        <div><strong id="player-title">{ps.program.title}</strong><span id="player-caption">{caption}</span></div>
      </div>
      <div className="player-transport">
        <button className="icon-button" onClick={() => player.seek(player.getState().position - 10)} aria-label="Back 10 seconds"><Icon name="rewind" /></button>
        <button className="player-toggle" onClick={toggle} aria-label={ps.playing ? "Pause" : "Play"}><Icon name={ps.playing ? "pause" : "play"} /></button>
        <button className="icon-button" onClick={() => player.seek(player.getState().position + 10)} aria-label="Forward 10 seconds"><Icon name="forward" /></button>
      </div>
      <div className="player-timeline">
        <span>{formatTime(drag ?? ps.position)}</span>
        <input
          id="player-seek" type="range" min={0} max={Math.max(1, ps.duration)} step={0.1} value={drag ?? ps.position}
          aria-label="Playback position"
          onChange={(e) => setDrag(Number(e.target.value))}
          onPointerUp={commitSeek} onKeyUp={commitSeek} onBlur={commitSeek}
        />
        <span>{formatTime(ps.duration)}</span>
      </div>
      <select id="player-speed" aria-label="Playback speed" value={ps.rate || 1} onChange={(e) => changeRate(Number(e.target.value))}>
        {RATES.map((n) => <option key={n} value={n}>{n}×</option>)}
      </select>
      <button className="icon-button player-close" onClick={() => player.stop()} aria-label="Close audio player"><Icon name="close" /></button>
      <p id="player-error" role="alert" hidden={!ps.error}>{ps.error ? "Audio couldn’t play. Check your connection, then tap play to retry." : ""}</p>
    </section>
  );
}
